import { render, staticRenderFns } from "./collectInformation.vue?vue&type=template&id=276f49a0&scoped=true&"
import script from "./collectInformation.vue?vue&type=script&lang=js&"
export * from "./collectInformation.vue?vue&type=script&lang=js&"
import style0 from "./collectInformation.vue?vue&type=style&index=0&id=276f49a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f49a0",
  null
  
)

export default component.exports